import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { PaymentResultGuard } from './payment-result.guard';
import { uuidValidatorGuard } from './guards/uuid-validator.guard';

export const routes: Routes = [
    {
        path: 'test',
        loadComponent: () => import('./components/prueba/prueba.component').then(m => m.PruebaComponent)
    },
    {
        path: '',
        loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
    },
    {
        path: 'tienda',
        loadComponent: () => import('./components/shop/shop.component').then(m => m.ShopComponent),
        canActivate: [AuthGuard],
        children: []
    },
    {
        path: 'politica-privacidad',
        loadComponent: () => import('./components/politica-privacidad/politica-privacidad.component').then(m => m.PoliticaPrivacidadComponent)
    },
    {
        path: 'politica-cookies',
        loadComponent: () => import('./components/politica-cookies/politica-cookies.component').then(m => m.PoliticaCookiesComponent)
    },
    {
        path: 'tienda/articulo/:id',
        loadComponent: () => import('./components/articulo-detalle/articulo-detalle.component').then(m => m.ArticuloDetalleComponent)
    },
    {
        path: 'compra',
        loadComponent: () => import('./components/checkout/checkout.component').then(m => m.CheckoutComponent)
    },
    {
        path: 'compra-finalizada',
        loadComponent: () => import('./components/compra-realizada/compra-realizada.component').then(m => m.CompraRealizadaComponent)
    },
    {
        path: 'payment-result',
        loadComponent: () => import('./components/payment-result/payment-result.component').then(m => m.PaymentResultComponent),
        canActivate: [PaymentResultGuard]
    },
    {
        path: 'entrega',
        loadComponent: () => import('./components/delivery/delivery.component').then(m => m.DeliveryComponent)
    },
    {
        path: 'portal',
        loadComponent: () => import('./components/portal/portal/portal.component').then(m => m.PortalComponent)
    },
    {
        path: 'CambioClave/:hash',
        loadComponent: () => import('./components/login-cambio-clave/login-cambio-clave.component').then(m => m.LoginCambioClaveComponent)
    },
    {
        path: 'CambioClave',
        loadComponent: () => import('./components/login-cambio-clave/login-cambio-clave.component').then(m => m.LoginCambioClaveComponent)
    },
    {
        path: 'OlvidoClave',
        loadComponent: () => import('./components/login-olvido-clave/login-olvido-clave.component').then(m => m.LoginOlvidoClaveComponent)
    },
    {
        // Más específica — debe ir ANTES de pagoOnline/:uuid
        path: 'pagoOnline/:uuid/resultado',
        loadComponent: () => import('./components/pago-online-resultado/pago-online-resultado.component').then(m => m.PagoOnlineResultadoComponent)
        // Sin guard — UUID y status vienen de la URL de retorno de Sipay
    },
    {
        path: 'pagoOnline/:uuid',
        loadComponent: () => import('./components/pago-online/pago-online.component').then(m => m.PagoOnlineComponent),
        canActivate: [uuidValidatorGuard]
        // Sin AuthGuard — acceso público via enlace email
    },
    {
        path: '**',
        redirectTo: ''
    }
];
